import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
// Material Symbols is loaded from a self-hosted SUBSET declared in styles.css,
// not from `material-symbols/rounded.css` (which pulls the full 5.35 MB font —
// unacceptable on Office's public landing page). See the note in styles.css.
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
